import React, { useReducer, createContext } from "react";
import { uiReducer, uiInitialState } from "../reducers";
import constant from "../constants/uiConstant";

export const UiContext = createContext();

export const UiContextProvider = (props) => {

    const [state, dispatch] = useReducer(uiReducer, uiInitialState);

    const setActiveItem = (activeItem) => {

        //todo: history'de forcerefresh true olduğu için state'leri öldürüyor
        //false olursa da arama sonuçlarını yenilemiyor homepage'de
        localStorage.setItem("should-finish-active-item", activeItem);

        dispatch({ type: constant.SET_SIDE_MENU_ACTIVE_ITEM, payload:activeItem  });
    }

    return (
        <UiContext.Provider value={[state,
            {
                setActiveItem
            }]}>
            {props.children}
        </UiContext.Provider>
    );
};

